import { render } from "./AccountInfo.vue?vue&type=template&id=225ee2ec&ts=true"
import script from "./AccountInfo.vue?vue&type=script&lang=ts"
export * from "./AccountInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__